/* @flow */
import createDebugger from 'debug';
import type { Action } from 'trustar/utils/redux-types.js';
import { combineReducers } from 'redux-immutable';
const debug = createDebugger('app:modules:chat:stores'); // eslint-disable-line no-unused-vars

import {
  JOIN_COMMUNITY_CHAT_CHANNEL,
  CHAT_INVITE_STATUS_UPDATE,
  CLOSE_CHAT_MODAL,
} from './action-types.js';

// Slack Community Chat
const joinRequestInProgress = (state = false, action) => {
  switch (action.type) {
    case JOIN_COMMUNITY_CHAT_CHANNEL:
      return true;
    case CHAT_INVITE_STATUS_UPDATE:
      return false;
    default:
      return state;
  }
};
const slackInvitationStatusInitialValue = {status: '', workspaceUrl: ''};
const slackInvitationStatus = (state: Object = slackInvitationStatusInitialValue, action: Action<string>) => {
  const { type, payload } = action;

  switch(type) {
    case CHAT_INVITE_STATUS_UPDATE:
      return payload;
    case CLOSE_CHAT_MODAL:
      return slackInvitationStatusInitialValue;
    default:
      return state;
  }
};

export const chatReducer = combineReducers({
  joinRequestInProgress,
  slackInvitationStatus,
});

export default chatReducer;



// WEBPACK FOOTER //
// ./src/app/modules/chat/stores.js